import React from "react";
import Accordion from "react-bootstrap/Accordion";

export default function SustainApproch() {
  const [active, setActive] = React.useState("0");
  const handleEventKey = (key)=>{
    if(active === key){
      setActive(null);
    }else{
      setActive(key);
    }
  }

  const imageData = [
    "/assets/images/sustain-approch-circle-img-1.webp",
    "/assets/images/sustain-approch-circle-img-2.webp",
    "/assets/images/sustain-approch-circle-img-3.webp",
  ]

  return (
    <>
      <section className="sustainapproch-area">
        <div className="container">
          <div className="row align-items-end justify-content-between">
            <div className="col-lg-6 col-md-6 order-1 order-md-0">
              <div className="sustainapproch-accor">
                <h2 className="heading">
                 Our approach to sustainability is based on: 
                </h2>
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0" className="accor-item" onClick={()=>handleEventKey("0")}>
                    <Accordion.Header className="accorcustom-header">
                      <div className="accor-lefticon">
                        <img  src="assets/images/sustain-approach-icon1.webp"     alt="Sustain Icon"  />
                        <span>Environment</span>
                      </div>
                      <div className="accor-righticon">
                        {active === "0"? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Our operations rely on physical infrastructure, logistics, technology—making responsible resource management essential. We are committed to reducing our environmental impact through optimized storage practices, energy-efficient facilities, enabling businesses to transition toward paperless ecosystems.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1" className="accor-item" onClick={()=>handleEventKey("1")}>
                    <Accordion.Header className="accorcustom-header">
                      <div className="accor-lefticon">
                        <img
                          src="assets/images/sustain-approach-icon2.webp"
                          alt="Sustain Icon"  />
                        <span>Social</span>
                      </div>

                      <div className="accor-righticon">
                        {active === "1"? "-" : "+"}
                      </div>
                    </Accordion.Header>

                    <Accordion.Body>We believe in building a responsible and inclusive workplace while contributing positively to the communities around us. Our focus lies in fostering a culture of collaboration, diversity, ethical practices, while ensuring the safety, well-being, growth of our people.</Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2" className="accor-item" onClick={()=>handleEventKey("2")}>
                    <Accordion.Header className="accorcustom-header">
                      <div className="accor-lefticon">
                        <img src="assets/images/sustain-approach-icon3.webp"   alt="Sustain Icon"  />
                        <span>Governance</span>
                      </div>

                      <div className="accor-righticon">
                        {active === "2"? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Strong governance is the foundation of sustainable growth. At Dox and Box, we follow transparent, ethical, compliant business practices across all operations. From secure data handling to regulatory compliance and risk management, we ensure that our processes meet the highest standards of accountability and trust.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>

            <div className="col-lg-5 col-md-6 order-0 order-md-1">
              <div className="sustainapprch-circle">
                {/* <img
                  src="/assets/images/sustain-approch-circle-img.webp"
                  alt="sustain-approch-circle"
                /> */}
                <img src={imageData[active]}  alt="Redefine"  loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sustainapproch-second">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-5 col-md-6">
                <img src="/assets/images/sustain-approch-circle-img2.webp" alt="Sustain Approch Circle" /> 
            </div>

            <div className="col-lg-7 col-md-6 ">
              <div className="sustainapproch-secondtext">
                <h3 className="heading">Sustainability at Dox and Box</h3>
                <p>We are continuously strengthening our commitment to sustainability by embedding responsible practices into every aspect of our business. Our focus includes efficient resource utilization, adoption of advanced technologies, aligning our operations with evolving ESG standards.</p>
                <p>By integrating sustainability into our growth strategy, we aim to create long-term value for our clients, our people, the environment. Through innovation and responsible operations, Dox and Box is working toward a smarter, more sustainable future for information management.</p>
                <small>Rahul Mehra, CEO at Dox and Box</small>
              </div>
            </div>
          </div>
        </div>

      </section>
    </>
  );
}
